"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleCalendarActionsContext = exports.OpScheduleCalendarSelectContext = exports.OpScheduleCalendarContext = exports.OpScheduleCalendarController = void 0;
const calcTicksForSchedule_1 = __importDefault(require("@opsbase/lib-time/helpers/calcTicksForSchedule"));
const shiftTZUTCToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZUTCToLocal"));
const useOpSchedules_1 = __importDefault(require("@opsbase/react-gql-hooks/opschedule/useOpSchedules"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const calcScheduleTitle_1 = __importDefault(require("../helpers/calcScheduleTitle"));
const CalendarViewType_1 = __importDefault(require("../OpScheduleCalendar/CalendarViewType"));
function OpScheduleCalendarController(props) {
    const { children, opDefinition } = props;
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const [selCtxChanged, setSelCtxChanged] = (0, react_1.useState)();
    const loading = (0, react_1.useRef)(false);
    const selectedEvent = (0, react_1.useRef)();
    const selectedSchedule = (0, react_1.useRef)();
    const date = (0, react_1.useRef)((0, moment_timezone_1.default)());
    const from = (0, react_1.useRef)(calcFrom(date.current));
    const to = (0, react_1.useRef)(calcTo(date.current));
    const calendarView = (0, react_1.useRef)(CalendarViewType_1.default.MONTH);
    const allPlaces = (0, react_1.useRef)(true);
    const places = (0, react_1.useRef)([]);
    const events = (0, react_1.useRef)([]);
    const schedules = (0, react_1.useRef)([]);
    // Load Schedules
    const variables = (0, react_1.useMemo)(() => {
        var _a;
        return ({
            opDefinition: opDefinition ? [opDefinition.id] : [],
            place: places.current ? [...(_a = places.current) === null || _a === void 0 ? void 0 : _a.map(p => p.id)] : [],
        });
    }, [opDefinition, places.current]);
    const { loading: schedLoading, data: schedData } = (0, useOpSchedules_1.default)({
        variables,
        skip: !opDefinition,
    });
    const _doCreateEvents = (0, react_1.useMemo)(() => () => {
        var _a, _b;
        schedules.current = schedData || [];
        events.current = (0, flatten_1.default)(schedules.current.map(schedule => createEventsForSchedule(from.current, to.current, schedule)));
        if (!!((_a = selectedEvent.current) === null || _a === void 0 ? void 0 : _a.id)) {
            selectedEvent.current = events.current.find(s => { var _a; return s.id === ((_a = selectedEvent.current) === null || _a === void 0 ? void 0 : _a.id); });
            selectedSchedule.current = (_b = selectedEvent.current) === null || _b === void 0 ? void 0 : _b.opSchedule;
            setSelCtxChanged(new Date());
        }
        loading.current = false;
        setCtxChanged(new Date());
    }, [schedData]);
    // Convert Schedules into Events
    // We want to return 1 month of events each side of the date provided
    (0, react_1.useEffect)(() => {
        loading.current = true;
        events.current = [];
        if (schedLoading)
            return;
        setTimeout(_doCreateEvents, 0);
        setCtxChanged(new Date());
    }, [schedLoading, schedData, opDefinition]);
    const ctx = (0, react_1.useMemo)(() => ({
        opDefinition,
        loading: loading.current,
        events: events.current,
        schedules: schedules.current,
        date: date.current,
        calendarView: calendarView.current,
        allPlaces: allPlaces.current,
        places: places.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged]);
    const selCtx = (0, react_1.useMemo)(() => ({
        selectedEvent: selectedEvent.current,
        selectedSchedule: selectedSchedule.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selCtxChanged]);
    const doSelectEvent = (0, react_1.useMemo)(() => v => {
        var _a;
        const newEvent = ((_a = selectedEvent.current) === null || _a === void 0 ? void 0 : _a.id) === (v === null || v === void 0 ? void 0 : v.id) ? undefined : v;
        selectedEvent.current = newEvent;
        selectedSchedule.current = newEvent === null || newEvent === void 0 ? void 0 : newEvent.opSchedule;
        setSelCtxChanged(new Date());
    }, []);
    const doSelectSchedule = (0, react_1.useMemo)(() => v => {
        var _a;
        selectedEvent.current = undefined;
        selectedSchedule.current = ((_a = selectedSchedule.current) === null || _a === void 0 ? void 0 : _a.id) === (v === null || v === void 0 ? void 0 : v.id) ? undefined : v;
        setSelCtxChanged(new Date());
    }, []);
    const doChangeDate = (0, react_1.useMemo)(() => (v) => {
        loading.current = true;
        date.current = v;
        from.current = calcFrom(v);
        to.current = calcTo(v);
        events.current = [];
        setTimeout(_doCreateEvents, 0);
        setCtxChanged(new Date());
    }, [_doCreateEvents]);
    const doChangeCalendarView = (0, react_1.useMemo)(() => (v) => {
        calendarView.current = v;
        setCtxChanged(new Date());
    }, []);
    const doChangePlaces = (0, react_1.useMemo)(() => (v) => {
        allPlaces.current = false;
        places.current = v;
        setCtxChanged(new Date());
    }, []);
    const doChangeAllPlaces = (0, react_1.useMemo)(() => (v) => {
        allPlaces.current = v;
        if (v) {
            places.current = [];
        }
        setCtxChanged(new Date());
    }, []);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        doSelectEvent,
        doSelectSchedule,
        doChangeDate,
        doChangeCalendarView,
        doChangeAllPlaces,
        doChangePlaces,
    }), [
        doSelectEvent,
        doSelectSchedule,
        doChangeDate,
        doChangeCalendarView,
        doChangePlaces,
        doChangeAllPlaces,
    ]);
    return (react_1.default.createElement(exports.OpScheduleCalendarContext.Provider, { value: ctx },
        react_1.default.createElement(exports.OpScheduleCalendarSelectContext.Provider, { value: selCtx },
            react_1.default.createElement(exports.OpScheduleCalendarActionsContext.Provider, { value: actionsCtx }, children))));
}
exports.OpScheduleCalendarController = OpScheduleCalendarController;
exports.default = OpScheduleCalendarController;
exports.OpScheduleCalendarContext = react_1.default.createContext(null);
exports.OpScheduleCalendarSelectContext = react_1.default.createContext(null);
exports.OpScheduleCalendarActionsContext = react_1.default.createContext(null);
function calcFrom(v) {
    return v.clone().startOf('month').subtract(1, 'week').set('second', 0).set('millisecond', 0);
}
function calcTo(v) {
    return v.clone().endOf('month').add(1, 'week').set('second', 0).set('millisecond', 0);
}
function createEventsForSchedule(from, to, opSchedule) {
    // Now, calculate all ticks that take place between our from and to dates
    const ticks = (0, calcTicksForSchedule_1.default)(from.toDate(), to.toDate(), opSchedule);
    // No ticks found, return an empty array
    if (!ticks || ticks.length === 0)
        return [];
    // Convert our ticks into events
    // Return the events
    return ticks.map(due => {
        const start = (0, shiftTZUTCToLocal_1.default)((0, moment_timezone_1.default)(due).subtract(opSchedule.whenCanStart, 'minutes').toDate());
        const end = (0, shiftTZUTCToLocal_1.default)((0, moment_timezone_1.default)(due).toDate());
        const title = (0, calcScheduleTitle_1.default)(opSchedule, true);
        const id = opSchedule.id + '.' + end.toISOString();
        return { id, title, start, end, opSchedule };
    });
}
